import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SchoolDaySIS from './SchoolDaySIS';

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentInformationSystem',
  setup(__props) {

// eslint-disable-next-line vue/block-tag-newline

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(SchoolDaySIS))
  ]))
}
}

})